import React from 'react';

const CustomLoading = ({ type }) => {
  return (
    <div className='_Loading' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
      {type === 'linear' ? <span className='lazy-linear'></span> : <span className='lazy-loading'></span>}
    </div>
  );
};

export default CustomLoading;
